import React from "react";
import DashboardShell from "./dashboard/DashboardShell";

const Layout = ({ pageTitle, children }) => (
  <DashboardShell pageTitle={pageTitle}>{children}</DashboardShell>
);

export default Layout;
